import React from 'react'
import DashboardComp from './components/Dashboard'
import Calendar from './Calendar'
import Birthdays from './Birthdays'
import MyTasks from './MyTasks'
import Announcements from './Announcements'

const Dashboard = props => {
	const items = [
		{ id: 1, x: 0, y: 0, width: 7, height: 30, title: '日程表', renderer: Calendar },
		{ id: 2, x: 7, y: 0, width: 3, height: 20, title: '公告栏', renderer: Announcements },
		{ id: 3, x: 7, y: 20, width: 3, height: 10, title: '本月寿星', renderer: Birthdays },
	]

	const dashProps = {
		// name: dashboardName = 'dashboard', 	// 名称，用于保存布局
		// columns = 10,				// 列数，默认为10
		// rowHeight: 20,				// 行高，有此值则rows无效；主要用于内容高度相对固定的情况(px)
		// rows = 30,				// 行数，默认为30，用于计算ratio
		// spacing = 5,			// 间隔大小(px)，默认为5
		// reset: false, 	// 重置主页按钮文本，转为''、null或false则不显示
		items,					// 元素内容对象数据: id, x, y, width, height, title, renderer
		// containerProps = {}		// extjs Container 属性
	}
	return <DashboardComp {...dashProps} />
}

export default Dashboard